import React from 'react';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ThemeProvider } from '@/components/ThemeProvider';
import { AuthProvider } from '@/contexts/AuthContext';
import { BackgroundTaskProvider } from '@/contexts/BackgroundTaskContext';
import { OfflineProvider } from '@/components/OfflineProvider';

interface ProviderProps { children: React.ReactNode; }

export const ProviderChain: React.FC<ProviderProps> = ({ children }) => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <OfflineProvider>
          <BackgroundTaskProvider>
            <TooltipProvider>
              {children}
            </TooltipProvider>
          </BackgroundTaskProvider>
        </OfflineProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};
